import {handleToolCalls} from "./contentFormatters/formatToolCallMessage.ts";

export const addFormattedAssistantMessage = async (formattedMessages: any[], trimmedMessages: any[], index: number, currentNode: any, provider: string, model: string, addIfFound: any) => {
    const message = currentNode.message;
    let formattedMessage: any = {
        role: "assistant",
        content: [],
        tool_calls: null
    };

    for (const contentItem of message.content) {
        // Only include thinking blocks for Claude models with valid signatures (not dummy signatures from other providers)
        if ((model.includes("Sonnet") || model.includes("Opus")) && (contentItem.type === 'thinking' || contentItem.type === 'redacted_thinking') && contentItem.signature && contentItem.signature !== "dummy_signature") {
            formattedMessage.content.push(contentItem);
        }

        if (contentItem.type === 'text' && contentItem.text.trim() !== "") {
            formattedMessage.content.push({
                type: 'text',
                text: contentItem.text
            });
        }
    }

    const result = handleToolCalls(currentNode, trimmedMessages, index, provider, addIfFound);
    if (result) {
        const toolCalls = result;
        if (provider === "Anthropic") {
            toolCalls.forEach((toolCall: any) => {
                formattedMessage.content.push(toolCall);
            });
        } else {
            formattedMessage.tool_calls = toolCalls;
        }
    }

    // If there's no content or tool calls, append a text block with just an underscore
    if (formattedMessage.content.length === 0 && (!formattedMessage.tool_calls || formattedMessage.tool_calls.length === 0)) {
        formattedMessage.content.push({
            type: 'text',
            text: '_'
        });
    }

    formattedMessages.push(formattedMessage);

}